import { Flex, Text } from '@mantine/core'
import { useEffect, useState } from 'react'
// import DateAndFullNameColumn from '@components/table/DateAndFullNameColumn';
import TableViewButton from '@components/button/TableViewButton.'
import TableEditButton from '@components/button/TableEditButton'
import TableDeleteButton from '@components/button/TableDeleteButton'
import TablePagination from '@components/table/template/TablePagination'
import TableTemplate from '@components/table/template/TableTemplate'
import { ITHeadMap } from '@interfaces/ITable'
import { Link } from 'react-router-dom'
import TableAddNewButton from '@components/button/TableAddNewButton'
import { modals } from '@mantine/modals'
import { QueryObserverResult } from 'react-query'
import TableFilter from '@components/table/filter/TableFilter'
import {
    IResponseGetAllChairmanOrganizations,
    IResponseGetAllChairmanOrganizationsRowData,
} from '@interfaces/api/IChairmanOrganization'
import ChairmanOrganization from '@api/ChairmanOrganization'

const ROUTE_URL = '/chairmans/organizations'

const TableAllChairmanOrganization = () => {
    const [limit, setlimit] = useState(10)
    const [orderby, setorderby] = useState<
        keyof IResponseGetAllChairmanOrganizationsRowData
    >('chairman_organization_id')
    const [order, setorder] = useState('desc')
    const [page, setpage] = useState(1)
    const [search, setsearch] = useState('')
    const [checkowner, setcheckowner] = useState(0)
    const [status, setstatus] = useState('')

    const lists = ChairmanOrganization.useGetAllChairmanOrganizations({
        limit,
        orderby,
        order,
        page,
        search,
        checkowner,
        status,
    })

    useEffect(() => {
        lists.refetch()
        // eslint-disable-next-line
    }, [page, status, limit, order, orderby, checkowner])

    const thead: ITHeadMap<IResponseGetAllChairmanOrganizationsRowData>[] = [
        {
            sortkey: 'chairman_organization_name',
            label: 'ชื่อสังกัดประธานโครงการ',
            width: '70%',
        },
        {
            sortkey: 'status',
            label: 'สถานะ',
            width: '15%',
        },
        {
            label: 'Action',
            width: '10%',
        },
    ]

    return (
        <>
            <TableFilter
                {...{
                    lists,
                    setpage,
                    page,
                    setsearch,
                    search,
                    setcheckowner,
                    checkowner,
                    setstatus,
                    status,
                }}
            >
                <TableAddNewButton
                    component={Link}
                    to={`${ROUTE_URL}/create`}
                    label='เพิ่อสังกัดประธานโครงการ'
                />
            </TableFilter>

            <TableTemplate<IResponseGetAllChairmanOrganizationsRowData>
                thead={thead}
                orderby={orderby}
                order={order}
                setorder={setorder}
                setorderby={setorderby}
                lists={lists?.data?.lists}
            >
                {lists?.data?.lists.map((value) => (
                    <TableRow
                        key={value.chairman_organization_id}
                        data={value}
                        refreshTable={lists.refetch}
                    />
                ))}
            </TableTemplate>
            {lists.data?.lists.length ? (
                <TablePagination
                    limit={lists.data?.lists.length}
                    setlimit={setlimit}
                    setpage={setpage}
                    page={page}
                    totalPages={lists.data.totalPages}
                    totalRows={lists.data.totalRows}
                />
            ) : (
                <></>
            )}
        </>
    )
}

export default TableAllChairmanOrganization

const TableRow = ({
    data,
    refreshTable,
}: {
    data: IResponseGetAllChairmanOrganizationsRowData
    refreshTable: () => Promise<
        QueryObserverResult<IResponseGetAllChairmanOrganizations, unknown>
    >
}) => {
    const Delete = ChairmanOrganization.useDeleteChairman({
        chairman_organization_id: data.chairman_organization_id,
        aftersuccess: refreshTable,
    })

    const openDeleteConfirmModal = () =>
        modals.openConfirmModal({
            title: 'กรุณายืนยันการลบ',
            children: (
                <Text>
                    ลบสังกัดประธานโครงการ/ลูกค้า <br />
                    {data.chairman_organization_name}
                </Text>
            ),
            labels: { confirm: 'ยืนยัน', cancel: 'ยกเลิก' },
            onConfirm: Delete.onSubmit,
        })

    return (
        <tr key={data.chairman_organization_id}>
            <td>{data.chairman_organization_name}</td>
            <td>{data.status_description}</td>
            <td>
                <Flex gap='xs' pos='relative'>
                    <TableViewButton
                        component={Link}
                        to={`${ROUTE_URL}/${data.chairman_organization_id}/view`}
                    />
                    <TableEditButton
                        component={Link}
                        to={`${ROUTE_URL}/${data.chairman_organization_id}/edit`}
                    />
                    <TableDeleteButton onClick={openDeleteConfirmModal} />
                </Flex>
            </td>
        </tr>
    )
}
